<template>
  <div class="coupon">
    <svg class="bg" width="378" height="378" viewBox="0 0 378 378" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M271.688 248.062C278.211 248.062 283.5 242.774 283.5 236.25C283.5 229.726 278.211 224.438 271.688 224.438C265.164 224.438 259.875 229.726 259.875 236.25C259.875 242.774 265.164 248.062 271.688 248.062Z"/>
      <path d="M200.812 153.562C207.336 153.562 212.625 148.274 212.625 141.75C212.625 135.226 207.336 129.938 200.812 129.938C194.289 129.938 189 135.226 189 141.75C189 148.274 194.289 153.562 200.812 153.562Z"/>
      <path d="M354.375 59.0625H129.938C126.795 59.0625 123.795 60.3146 121.574 62.5117L106.312 77.7971L91.0508 62.5117C88.83 60.3146 85.8296 59.0625 82.6875 59.0625H23.625C10.6076 59.0625 0 69.6701 0 82.6875V295.312C0 308.353 10.6076 318.938 23.625 318.938H82.6875C85.8296 318.938 88.83 317.685 91.0508 315.488L106.312 300.203L121.574 315.465C123.795 317.685 126.795 318.938 129.938 318.938H354.375C367.416 318.938 378 308.353 378 295.312V82.6875C378 69.6701 367.416 59.0625 354.375 59.0625ZM118.125 271.688H94.5V248.062H118.125V271.688ZM118.125 224.438H94.5V200.812H118.125V224.438ZM118.125 177.188H94.5V153.562H118.125V177.188ZM118.125 129.938H94.5V106.312H118.125V129.938ZM200.812 106.312C220.35 106.312 236.25 122.212 236.25 141.75C236.25 161.288 220.35 177.188 200.812 177.188C181.275 177.188 165.375 161.288 165.375 141.75C165.375 122.212 181.275 106.312 200.812 106.312ZM177.188 271.688C174.518 271.688 171.848 270.79 169.627 268.947C164.619 264.765 163.934 257.324 168.116 252.315L286.241 110.565C290.446 105.533 297.888 104.919 302.872 109.053C307.881 113.235 308.543 120.677 304.361 125.709L186.236 267.459C183.921 270.223 180.566 271.688 177.188 271.688ZM271.688 271.688C252.15 271.688 236.25 255.788 236.25 236.25C236.25 216.712 252.15 200.812 271.688 200.812C291.225 200.812 307.125 216.712 307.125 236.25C307.125 255.788 291.225 271.688 271.688 271.688Z"/>
    </svg>

    <app-btn
      @click="showCoupon"
      class="quest"
      styling="inline"
    >{{$ml.get('Have a coupon?')}}</app-btn>

    <app-text-input
      @input="onInput"
      :label="$ml.get('Coupon')"
      v-if="show_coupon"
      :value="value"
    />

    <template v-if="show_result">
      <app-loading :loading="loading">
        <div class="result error" v-if="error">
          <i class="material-icons">close</i>
          {{ $ml.get(error) }}
        </div>
        <div class="result success" v-else-if="!error && coupon">
          <i class="material-icons">check</i>
          <template v-if="coupon.type === 'discount'">
            {{$ml.get('Valid coupon')}} <b>-{{ coupon.meta.percent }}%</b>
          </template>
        </div>
        <div class="updated-price" v-if="coupon.meta.percent && !error">
          <span>{{ finalPrice }} GBP</span>
          <del>{{price}} GBP</del>

        </div>
      </app-loading>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CouponsAPI } from '@/api'

export default {
  data() {
    return {
      show_coupon: false,
      error: false,
      show_result: false,
      loading: false,
      coupon: null,
    }
  },
  props: {
    value: {

    },
    price: {},
  },
  computed: {
    finalPrice: function() {
      return (this.price - (this.price * this.coupon.meta.percent / 100)).toFixed(2);
    },
  },
  methods: {

    onInput(value) {
      this.$emit('input', value);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {

        this.show_result = true;
        this.loading = true;
        const coupon = await CouponsAPI.check(this.value)
          .then(res => {
            this.error = false;
            this.coupon = res.data;
            return res.data;
          })
          .catch(err => {
            this.error = err.response.data.err;
          })
          .finally(() => {
            this.loading = false;
          });

      }, 300);
    },

    showCoupon() {
      this.show_coupon = true;
    },
  },
}
</script>

<style lang="scss" scoped>

.coupon {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding-bottom: 20px;
  padding: 20px;
  background: #f7f7f7;
  margin-bottom: 20px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  .updated-price {
    display: flex;
    margin-top: 8px;
    del {
      margin-left: 8px;
    }
    span {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .app-text-input {
    margin-top: 30px;
  }

  .bg {
    position: absolute;
    right: 20px;
    top: -20px;
    fill: #eee;
    width: auto;
    height: 80px;
    transform: rotate(-45deg);
  }

  .app-loading {
    margin-top: 20px;
    height: 50px;
    justify-content: center;
    align-items: flex-start;
  }

  .result {
    font-size: 14px;
    padding: 5px 8px;
    border-radius: 5px;

    display: flex;
    flex-direction: row;
    align-items: center;

    i {
      margin-right: 5px;
    }

    b {
      margin-left: 5px;
    }

    &.error {
      color: #E8282F;
      background: rgba(#E8282F, 0.2);
    }

    &.success {
      color: $mainGreen;
      background: rgba($mainGreen, 0.2);
    }
  }
}

</style>
